import React, { useEffect, useState } from "react";
import AOS from "aos"; // Importa a biblioteca AOS
import "aos/dist/aos.css"; // Importa os estilos do AOS
import styles from "./NoticiasSection.module.css";
import { getUltimasNoticias } from "../../../../services/NoticiasService";
import { FaImage } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
};

const NoticiaCard = ({ noticia, index }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 120; // limite de caracteres

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldTruncate = noticia.descricao && noticia.descricao.length > maxLength;
  const displayedDescription = shouldTruncate && !isExpanded
    ? noticia.descricao.substring(0, maxLength) + "..."
    : noticia.descricao;

  return (
    <div
      className={styles.noticiaCard}
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      {noticia.imagem && noticia.imagem.trim() !== "" ? (
        <img
          src={noticia.imagem}
          alt={noticia.titulo}
          className={styles.noticiaImage}
        />
      ) : (
        <div className={styles.noticiaImagePlaceholder}>
          <FaImage className={styles.iconPlaceholder} />
        </div>
      )}
      <div className={styles.noticiaContent}>
        <h3 className={styles.noticiaTitle}>{noticia.titulo}</h3>
        <p className={styles.noticiaDate}>{noticia.data}</p>
        <p className={styles.noticiaDescription}>
          {displayedDescription}
          {shouldTruncate && (
            <span
              onClick={handleToggleExpand}
              className={styles.verMaisLink}
            >
              {isExpanded ? " ver menos" : " ver mais"}
            </span>
          )}
        </p>
        <button
          className={styles.noticiaButton}
          onClick={() => navigate("/noticia/" + encodeURIComponent(noticia.titulo))}
        >
          Ler Mais
        </button>
      </div>
    </div>
  );
};

const NoticiasSection = () => {
  const [noticias, setNoticias] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000, // Duração da animação (1 segundo)
      once: true, // Executa a animação apenas uma vez
    });
  }, []);

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        const data = await getUltimasNoticias();
        const mappedNoticias = data.map((noticia) => ({
          id: noticia._id,
          titulo: noticia.titulo,
          descricao: noticia.textoDescription,
          data: formatDate(noticia.data),
          imagem: noticia.imagem,
        }));

        setNoticias(mappedNoticias);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      }
    };
    fetchNoticias();
  }, []);

  return (
    <div className={styles.noticiasContainer}>
      <h2
        className={styles.sectionTitle}
        data-aos="fade-up" // Título aparece de baixo para cima
      >
        Últimas Notícias
      </h2>
      <div className={styles.noticiasGrid}>
        {noticias.map((noticia, index) => (
          <NoticiaCard key={noticia.id} noticia={noticia} index={index} />
        ))}
      </div>
    </div>
  );
};

export default NoticiasSection;
